export enum IntakePatientProfileTab {
  PATIENT_DETAILS = "Patient Details",
  PATIENT_CARE_DIRECTIVES = "Documents and Care Directives",
  DIAGNOSIS = "Diagnosis",
  BENEFITS = "Benefits",
  CERTIFICATIONS = "Certifications",
  DOCUMENTS = "Uploaded Documents",
}



// WEBPACK FOOTER //
// ./src/components/intake-queue/models/intake-patient-profile-type.ts